export default __webpack_public_path__ + "static/media/echallan_status.9ca4be0d.svg";